import OnBoardNeofintechRoutes from './neofintech/neofintech'

export default [
  {
    path: '/on-board',
    name: 'onBoard',
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/OnBoard.vue'
      ),
    children: [
      {
        path: '',
        name: 'onBoard.start',
        meta: {
          prev: null,
          next: null,
          name: null,
          hasBottomBar: false,
          hasSideBox: false
        },
        component: () =>
          import(
            /* webpackChunkName: "onboard" */
            '@/views/on-board/OnBoardStart.vue'
          )
      },
      OnBoardNeofintechRoutes
    ]
  }
]
